import React from 'react'
import { useSelector } from 'react-redux'
import TicketsCounterManager from 'components/TicketsCounterManager'
import TicketsPanel from 'components/TicketsPanel'

const Panels = () => {
  const { auth } = useSelector(({ auth }) => auth)

  return (
    <div>
      {auth && (
        <>
          <TicketsCounterManager />
          <TicketsPanel />
        </>
      )}
    </div>
  )
}

export default Panels
